import { useRef, useState } from "react";

export default function DateOfBirthInput() {
    const [day, setDay] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");

    const dayRef = useRef<HTMLInputElement>(null);
    const monthRef = useRef<HTMLInputElement>(null);
    const yearRef = useRef<HTMLInputElement>(null);

    const handleDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value.replace(/\D/g, "");

        if (value.length === 1 && Number(value) > 3) {
            value = `0${value}`;
        }

        if (value === "00") return;

        const num = Number(value);

        if (num > 31) return;

        setDay(value)

        if (value.length === 2) {
            monthRef.current?.focus();
        }
    };

    const handleDayBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;

        if (value.length === 1 && value !== "0") {
            setDay(value.padStart(2, "0"));
        }
    };

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value.replace(/\D/g, "");
        if (value.length === 1 && Number(value) > 1) {
            value = `0${value}`;
        }

        if (value === "00") return;

        const num = Number(value);

        if (num > 12) return;

        setMonth(value);

        if (value.length === 2) {
            yearRef.current?.focus();
        }
    };

    const handleMonthBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;

        if (value.length === 1 && value !== "0") {
            setMonth(value.padStart(2, "0"));
        }
    };

    const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, "");
        setYear(value);
    };

    const handleMonthKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Backspace" && !month) {
            dayRef.current?.focus();
        }
    };

    const handleYearKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Backspace" && !year) {
            monthRef.current?.focus();
        }
    };

    const buildDOB = () => {
        if (!day || !month || !year) return "";

        const yyyy = Number(year);
        const mm = Number(month);
        const dd = Number(day);

        const date = new Date(yyyy, mm - 1, dd);

        const isValid =
            date.getFullYear() === yyyy &&
            date.getMonth() === mm - 1 &&
            date.getDate() === dd;

        if (!isValid) return "";

        return `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
    };

    const dobValue = buildDOB()

    return (
        <div>
            <input
                id="dobDay"
                name="dobDay"
                autoComplete="bday-day"
                ref={dayRef}
                type="text"
                placeholder="DD"
                maxLength={2}
                inputMode="numeric"
                value={day}
                onChange={handleDayChange}
                onBlur={handleDayBlur}
            />
            <span>/</span>
            <input
                id="dobMonth"
                name="dobMonth"
                autoComplete="bday-month"
                ref={monthRef}
                type="text"
                placeholder="MM"
                maxLength={2}
                inputMode="numeric"
                value={month}
                onChange={handleMonthChange}
                onKeyDown={handleMonthKeyDown}
                onBlur={handleMonthBlur}
            />
            <span>/</span>
            <input
                id="dobYear"
                name="dobYear"
                autoComplete="bday-year"
                ref={yearRef}
                type="text"
                placeholder="YYYY"
                maxLength={4}
                inputMode="numeric"
                value={year}
                onChange={handleYearChange}
                onKeyDown={handleYearKeyDown}
            />
            {/* This is what FormData reads */}
            <input type="hidden" name="dateOfBirth" value={dobValue} />
        </div>
    );
}